<template>
  <div v-if="info" class="container">
    <div class="title">基本信息</div>
    <Button @click="download" class="download-btn" type="warning" icon="ios-cloud-download-outline" v-if="fileId">附件简历</Button>
    <Row type="flex" align="middle">
      <img class="avatar" :src="info.avatar ? info.avatar : avatar" alt="" />
      <Col flex="1">
        <div>
          <span class="name">{{ info.name }}</span>
          <span class="light">{{ info.sex }}&ensp;&ensp;·&ensp;&ensp;</span>
          <span class="light">{{ info.age }}岁&ensp;&ensp;·&ensp;&ensp;</span>
          <span class="light">{{ info.degree }}&ensp;&ensp;·&ensp;&ensp;</span>
          <span class="light">{{ info.workYearsString }}</span>
        </div>
        <div>
          <i class="ivu-icon ivu-icon-ios-mail-outline" style="margin: 0 10px 0 0; font-size: 18px"></i>
          <span class="light">{{ info.email }}</span>
        </div>
      </Col>
    </Row>
    <div class="title">求职状态</div>
    <div class="text">{{ info.workStatus }}</div>
    <div class="title">求职意向</div>
    <div class="text">
      <div v-for="(item, index) in info.expectations" :key="index">
        <span class="expectation-content">{{ item.city }}</span>
        &ensp;·&ensp;
        <span class="expectation-title">{{ item.position }}</span>
        &ensp;·&ensp;
        <span class="expectation-content">
          {{ item.salaryString }}
        </span>
      </div>
    </div>
    <div class="title">自我评价</div>
    <div class="text" style="white-space: pre-wrap">{{ info.selfComment }}</div>
    <div class="title">工作经历</div>
    <div v-for="(item, index) in info.jobExperience" :key="index">
      <Row class="text" type="flex" justify="space-between">
        <Col>{{ item.companyName }}&ensp;·&ensp;{{ item.workPlace }}&ensp;·&ensp;{{ item.position }}</Col>
        <Col>{{ item.startDate }} - {{ item.endDate }}</Col>
      </Row>
      <div class="job-detail">
        <div v-if="item.jobContent">
          <p>工作描述：</p>
          {{ item.jobContent }}
        </div>
        <div v-if="item.performance">
          <p>工作业绩</p>
          {{ item.performance }}
        </div>
      </div>
    </div>
    <div class="title">教育经历</div>
    <div v-for="(item, index) in info.education" :key="index">
      <Row class="text" type="flex" justify="space-between">
        <Col>{{ item.school }}&ensp;·&ensp;{{ item.education }}&ensp;·&ensp;{{ item.major }}</Col>
        <Col>{{ item.startDate }} - {{ item.endDate }}</Col>
      </Row>
    </div>
    <div class="title">证书</div>
    <div>
      <Tag color="blue" v-for="(item, index) in info.certificate" :key="index" style="margin-top: 10px;">
        {{ item.title }}
      </Tag>
    </div>

    <div class="footer">
      <Row type="flex" justify="center">
        <Col>
          <Button style="margin: 10px" @click="remove(companyTalentId)" v-if="companyTalentId">移出人才库</Button>
          <Button style="margin: 10px" @click="collect(info.id || info.resumeId, jobId)" v-else-if="jobId">加入人才库</Button>
          <Button style="margin: 10px" v-if="jobId" @click="sayHi(info.userId, jobId)">打招呼</Button>
          <Button style="margin: 10px" @click="invite(info)" v-if="noInterview">邀请面试</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import resumemixin from './resumemixin';
import avatar from '@/assets/images/avatar.png';
import { mapState } from 'vuex';
import { TUIConversationService } from '@tencentcloud/chat-uikit-engine';
export default {
  name: '',
  mixins: [resumemixin],
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    jobId: {
      type: Number,
      default: 0
    },
    fileId: null,
    fileName: '',
    companyTalentId: {
      type: Number,
      default: 0
    },
    noInterview: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState({
      timPrefix: state => state.user.timPrefix
    })
  },
  data() {
    return {
      avatar: avatar
    };
  },
  methods: {
    download() {
      this.$axios
        .request({
          methods: 'get',
          url: '/front/v1/common/file/downResume/' + this.fileId,
          responseType: 'blob'
        })
        .then(e => {
          let a = document.createElement('a');
          a.href = window.URL.createObjectURL(e);
          a.download = this.fileName;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
        });
    },
    remove(companyTalentId) {
      this.$emit('remove', companyTalentId);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.download-btn {
  position: absolute;
  right: 20px;
  top: 0;
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
  &::before {
    content: '';
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: -10px;
    width: 3px;
    background: #ffa4a2;
  }
}
.light {
  color: #999999;
  font-size: 14px;
}
.avatar {
  height: 65px;
  width: 65px;
  border-radius: 65px;
  background: #ccc;
  margin: 10px 15px 10px 0;
}
.name {
  color: #333333;
  font-size: 20px;
  margin: 0 30px 0 0;
}
.text {
  font-size: 14px;
  color: #333;
  margin: 10px 0;
  padding: 0 10px;
}
.job-detail {
  background: #fff8f8;
  padding: 20px;
  white-space: pre-wrap;
}
</style>
